import { Editor, EditorTools } from '@progress/kendo-react-editor';
import "@progress/kendo-theme-default/dist/default-blue.scss";
import {useEffect} from "react";

type RichTextEditorProps = {
  initialData: string;
  onChange?: (data: string) => void;
};

const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  Undo,
  Redo,
  FontSize,
  FontName,
  FormatBlock,
  Link,
  Unlink,
  InsertImage,
  ViewHtml,
  InsertTable,
  AddRowBefore,
  AddRowAfter,
  AddColumnBefore,
  AddColumnAfter,
  DeleteRow,
  DeleteColumn,
  DeleteTable,
  MergeCells,
  SplitCell,
} = EditorTools;

const RichTextEditor = (props: RichTextEditorProps) => {
  const { initialData, onChange } = props;

  return (
    <Editor
      tools={
       [
              [Bold, Italic, Underline, Strikethrough],
              [Subscript, Superscript],
              [AlignLeft, AlignCenter, AlignRight, AlignJustify],
              [Indent, Outdent],
              [OrderedList, UnorderedList],
              FontSize,
              FontName,
              FormatBlock,
              [Undo, Redo],
              [Link, Unlink, InsertImage, ViewHtml],
              [InsertTable],
              [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
              [DeleteRow, DeleteColumn, DeleteTable],
              [MergeCells, SplitCell],
       ]
      }
      onChange={(event) => {
        onChange && onChange(event.html);
      }}
      contentStyle={{ height: 630}}
      defaultContent={initialData}
    />
  );
};

export default RichTextEditor;
